<template>
  <div id="faq-section container" class="overflow-hidden">
    <div class="lg:w-3/5 lg:mx-auto pb-16">
      <div v-if="questions" class="border-t border-secondary">
        <div v-for="(item, index) in faqs" :key="item.title">
          <div class="tab__header">
            <a href="#" :class="index === active ? 'border-b-0' : 'border-b'" class="px-3 py-2 no-underline text-secondary border-secondary flex justify-between items-center" @click.prevent="setActive(index)">
              <span class="font-semibold leading-loose pr-4">{{ item.question }}</span>
              <span v-show="index !== active">
                <font-awesome-icon :icon="['far', 'chevron-down']" size="1x"/>
              </span>
              <span v-show="index === active">
                <font-awesome-icon :icon="['far', 'chevron-up']" size="1x"/>
              </span>
            </a>
          </div>
          <transition name="slide">
            <div v-show="index === active" class="px-3 pb-3 border-b border-secondary">
              {{ item.answer }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    text: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      active: null,
    };
  },
  computed: {
    ...mapState({
      questions: state => state.questions,
      highlightedQuestions: state => state.highlightedQuestions,
    }),
    faqs() {
      if (this.$route.path === '/veelgestelde-vragen') {
        return this.questions;
      } else {
        return this.highlightedQuestions;
      }
    },
  },
  methods: {
    setActive(index) {
      if (index === this.active) {
        this.active = null;
      } else {
        this.active = index;
      }
    },
  },
};
</script>

<style scoped>
.slide-enter-active {
  transition-duration: .3s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: .1s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
